import { useTranslation } from 'react-i18next';
import { chooseLanguage, LANGUAGES, localeFor } from 'i18n';

/**
 * The active UI language and the visitor's way to change it.
 *   const { language, locale, setLanguage } = useLanguage();
 * `locale` ("id-ID" / "en-GB") is for dates and plain numbers.
 */
export default function useLanguage() {
  const { i18n } = useTranslation();
  const language = LANGUAGES.includes(i18n.language) ? i18n.language : 'id';
  return { language, locale: localeFor(language), languages: LANGUAGES, setLanguage: chooseLanguage };
}
